const base = {
	black: "#000",
	white: "#fff",
};

const messages = {
	success: "#2ed0ac",
	error: "#ff3b3b",
	warning: "#ffd943",
};

const fp = {
	pineGreen: "#61a60e",
	pineGreen5: "#f6f9f2",
	pineGreen10: "#eff5e7",
	pineGreen20: "#e0ecd1",
	pineGreen40: "#c2dba4",
	pineGreen60: "#a3c978",
	pineGreen80: "#83B84B",
	teal: "#007481",
	teal10: "#E5EFF1",
	brightBlue: "#00b2e3",
	lightBlue: "#ACE0F3",
	deepRed: "#e53e51",

};

const grey = {
	charcoal: "#53575a",

};

const Colors = {
	base,
	grey,
	fp,
	messages
};

export default Colors;
